import { render, staticRenderFns } from "./MenuReportCredit.vue?vue&type=template&id=212466b3&scoped=true&"
import script from "./MenuReportCredit.vue?vue&type=script&lang=js&"
export * from "./MenuReportCredit.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportCredit.vue?vue&type=style&index=0&id=212466b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212466b3",
  null
  
)

export default component.exports